module.exports = __webpack_public_path__ + "img/class-setting.0c12d5b2.png";